import { Component } from '@angular/core'

@Component({
    selector: 'app-footer',
    templateUrl: './content-footer.component.html',
    standalone: true,
})
export class ContentFooterComponent {
  constructor() {}
}
